import React from 'react';
import { bool } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_PICKUP_FEE, LINE_ITEM_SHIPPING_FEE, propTypes } from '../../util/types';
import { types as sdkTypes } from '../../util/sdkLoader';

import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;

const LineItemShippingFeeMaybe = props => {
  const { lineItems, intl, alwaysShow, showZeroShippingFallback } = props;

  const shippingFeeLineItem = lineItems.find(
    item => item.code === LINE_ITEM_SHIPPING_FEE && !item.reversal
  );
  const pickupFeeLineItem = lineItems.find(
    item => item.code === LINE_ITEM_PICKUP_FEE && !item.reversal
  );

  // If checkout was pickup, show only pickup line and hide shipping row.
  if (pickupFeeLineItem && !shippingFeeLineItem) {
    return null;
  }

  const fallbackCurrency =
    (shippingFeeLineItem && shippingFeeLineItem.lineTotal?.currency) ||
    lineItems.find(item => item?.lineTotal?.currency || item?.unitPrice?.currency)?.lineTotal?.currency ||
    lineItems.find(item => item?.lineTotal?.currency || item?.unitPrice?.currency)?.unitPrice?.currency ||
    null;
  const zeroShippingMoney = fallbackCurrency ? new Money(0, fallbackCurrency) : null;

  // When shipping fee line-item exists, amount 0 is still a valid amount (e.g. free shipping).
  const displayValue = shippingFeeLineItem
    ? formatMoney(intl, shippingFeeLineItem.lineTotal)
    : showZeroShippingFallback && zeroShippingMoney
    ? formatMoney(intl, zeroShippingMoney)
    : 'Enter address';

  // Always show shipping line item if alwaysShow is true, or if shipping fee line item exists
  return alwaysShow || shippingFeeLineItem ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.shippingFee" />
      </span>
      <span className={css.itemValue}>{displayValue}</span>
    </div>
  ) : null;
};

LineItemShippingFeeMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
  alwaysShow: bool,
  showZeroShippingFallback: bool,
};

LineItemShippingFeeMaybe.defaultProps = {
  alwaysShow: false,
  showZeroShippingFallback: false,
};

export default LineItemShippingFeeMaybe;
